import { API_DATE_STRING_FORMAT, DATE_STRING_FORMAT } from "../../../Constants/stringFormats";
import { formatDateString } from "../../../Utils/stringUtils";
import { ResultValue}  from "../../Simple";

export default function DialysisDetails(props) {
    return (<>
        <h4>Dialysis Details</h4>
        <ResultValue label="Dialysis Onset Date" value={formatDateString(props.result.dialysisOnsetDate, API_DATE_STRING_FORMAT, DATE_STRING_FORMAT)} />
        <ResultValue label="Dialysis Sessions" value={props.result.dialysisSessions} />
        <ResultValue label="Dialysis Claim Type" value={props.result.dialysisClaimType} />
        <ResultValue label="Dialysis Modality" value={props.result.dialysisModality} />
    </>);
}